import React from "react";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { Field } from "formik";
import { i18n } from "../../translate/i18n";

const filterOptions = createFilterOptions({
	matchFrom: "any",
	limit: 200,
	stringify: option => option,
});

const popperProps = { style: { zIndex: 10004 } };

export const normalizeSelectOptions = options =>
	(options || [])
		.map(o => (typeof o === "string" ? o : o?.value ?? ""))
		.filter(Boolean);

/**
 * Select com filtro por texto (MUI Autocomplete) integrado ao Formik.
 */
const ContactFieldAutocomplete = ({
	name,
	label,
	options = [],
	multiple = false,
	maxSelections = 0,
	disabled = false,
}) => {
	const opts = normalizeSelectOptions(options);

	if (!multiple) {
		return (
			<Field name={name}>
				{({ field, form }) => (
					<Autocomplete
						options={opts}
						value={field.value ? field.value : null}
						onChange={(_, newValue) =>
							form.setFieldValue(field.name, newValue || "")
						}
						disabled={disabled}
						filterOptions={filterOptions}
						openOnFocus
						handleHomeEndKeys
						isOptionEqualToValue={(a, b) => a === b}
						noOptionsText={i18n.t("contactModal.form.noOptionsMatch")}
						componentsProps={{ popper: popperProps }}
						renderInput={params => (
							<TextField
								{...params}
								label={label}
								variant="outlined"
								margin="dense"
								fullWidth
								placeholder={i18n.t("contactModal.form.filterPlaceholder")}
							/>
						)}
					/>
				)}
			</Field>
		);
	}

	return (
		<Field name={name}>
			{({ field, form }) => {
				const raw = field.value;
				let selected = Array.isArray(raw) ? raw : raw ? [String(raw)] : [];
				selected = selected.filter(v => opts.includes(v));
				const max = Number(maxSelections) || 0;

				return (
					<>
						<Autocomplete
							multiple
							options={opts}
							value={selected}
							onChange={(_, newValue) => {
								let next = Array.isArray(newValue) ? newValue : [];
								if (max > 0 && next.length > max) {
									next = next.slice(0, max);
								}
								form.setFieldValue(field.name, next);
							}}
							disabled={disabled}
							filterOptions={filterOptions}
							filterSelectedOptions
							disableCloseOnSelect
							openOnFocus
							isOptionEqualToValue={(a, b) => a === b}
							noOptionsText={i18n.t("contactModal.form.noOptionsMatch")}
							componentsProps={{ popper: popperProps }}
							renderInput={params => (
								<TextField
									{...params}
									label={label}
									variant="outlined"
									margin="dense"
									fullWidth
									placeholder={i18n.t("contactModal.form.filterPlaceholder")}
								/>
							)}
						/>
						{max > 0 ? (
							<Typography
								variant="caption"
								color="textSecondary"
								style={{ marginTop: 4 }}
							>
								{`${selected.length}/${max}`}
							</Typography>
						) : null}
					</>
				);
			}}
		</Field>
	);
};

export default ContactFieldAutocomplete;
